require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-responsive-web-design-projects-build-a-product-landing-page.json") })
        }
      }, "path---responsive-web-design-responsive-web-design-projects-build-a-product-landing-page");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-responsive-web-design-projects-build-a-product-landing-page!./.cache/json/responsive-web-design-responsive-web-design-projects-build-a-product-landing-page.json
// module id = 2707
// module chunks = 231608221292675